import Vue from 'vue'
import RecommendedEvent from '../RecommendedEvent.vue'
import LoadScript from 'vue-plugin-load-script'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(LoadScript)
Vue.use(Vue2TouchEvents, {disableClick: false})
Vue.config.productionTip = false

new Vue({
  render: h => h(RecommendedEvent)
}).$mount('#app')